import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import currencyFlags from "../../Data/CurrencyFlags.json"; // Import currency flags JSON
import AgentTabs from "../AllTabs/AgentTabs";
import CompanyMenu from "./CompanyMenu";

const Agent = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState({
    companyId: "00000000-0000-0000-0000-000000000000",
    companyName: "",
    brandName: "",
    gstNo: "",
    email: "",
    phoneNumber: "",
    logoName: "",
    address: "",
    city: "",
    state: "",
    country: user?.country || "IN", // Set user's country as default
    currency: user?.currency || "INR", // Set user's currency as default
    companyType: "AGENT",
    parentCompanyId: "00000000-0000-0000-0000-000000000000",
    isActive: true,
    planType: "CUSTOM",
    userType: "AGENT",
  });
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [countries, setCountries] = useState([]);
  const [newPassword, setNewPassword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");

  // Process countries data from currencyFlags.json
  useEffect(() => {
    if (currencyFlags && Array.isArray(currencyFlags)) {
      const sortedCountries = [...currencyFlags].sort((a, b) =>
        a.country.localeCompare(b.country)
      );
      setCountries(sortedCountries);
    }
  }, []);

  // Get user's default currency and country
  const getUserDefaultCurrency = () => {
    return user?.currency || "INR";
  };

  const getUserDefaultCountry = () => {
    return user?.country || "IN";
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    // Reset form with user's defaults
    setValues({
      companyId: "00000000-0000-0000-0000-000000000000",
      companyName: "",
      brandName: "",
      gstNo: "",
      email: "",
      phoneNumber: "",
      logoName: "",
      address: "",
      city: "",
      state: "",
      country: getUserDefaultCountry(),
      currency: getUserDefaultCurrency(),
      companyType: "AGENT",
      parentCompanyId: "00000000-0000-0000-0000-000000000000",
      isActive: true,
      planType: "CUSTOM",
      userType: "AGENT",
    });
    setAddShow(true);
  };
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const [addCommissionShow, setAddCommissionShow] = useState(false);
  const handleAddCommissionShow = () => {
    setAddCommissionShow(true);
  };
  const handleAddCommissionClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const [showPassword, setShowPassword] = useState(false);
  const handlePasswordShow = (id) => {
    setItemToDelete(id);
    setShowPassword(true);
  };
  const handlePasswordClose = () => {
    setShowPassword(false);
  };
  const [showWallet, setShowWallet] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0);
  const handleWalletShow = (id) => {
    setItemToDelete(id)
    setShowWallet(true);
  };
  const handleWalletClose = () => {
    setShowWallet(false);
  };

  const [showMenuModal, setShowMenuModal] = useState(false);
  const [menuItem, setMenuItem] = useState(null);
  const handleOpenMenuModal = (id) => {
    setMenuItem(id);
    setShowMenuModal(true);
  };

  const handleCloseMenuModal = () => {
    setShowMenuModal(false);
    setMenuItem(null);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETCOMPANYAGENTS}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };

  const GetLastPageData = () => {
    GetData(totalPages);
  };

  const GetFirstPageData = () => {
    GetData("1");
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const filteredLists = lists.filter((v) => {
    const term = searchTerm.trim().toLowerCase();
    const matchesSearch =
      !term ||
      (v.companyName || "").toLowerCase().includes(term) ||
      (v.email || "").toLowerCase().includes(term);

    const matchesStatus =
      statusFilter === "ALL" ||
      (statusFilter === "ACTIVE" && v.isActive) ||
      (statusFilter === "INACTIVE" && !v.isActive);

    return matchesSearch && matchesStatus;
  });

  const handleClearFilters = () => {
    setSearchTerm("");
    setStatusFilter("ALL");
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETECOMPANY, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.companyName = values.companyName === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (newPassword === "") {
      alert("Please enter password")
    }
    else {
      setBtnLoading(true);
      var result = await apiService.post(config.CHANGEAGENTPASSWORD + "?Id=" + itemToDelete + "&Password=" + newPassword);
      alert(result);
      resetForm();
      setBtnLoading(false);
    }
  }
  const handleWalletSubmit = async (e) => {
    e.preventDefault();
    if (walletAmount === "") {
      alert("Please enter amount")
    }
    else {
      setBtnLoading(true);
      const payload = {
        companyId: itemToDelete,
        amount: walletAmount,
        status: "CREDITED",
      }
      var result = await apiService.post(config.CREATECOMPANYWALLET, payload);
      if (result) {
        alert("Topup updated successfully");
        GetData(pageNumber);
      }
      else {
        alert("Failed to update Topup");
      }
      resetForm();
      setBtnLoading(false);
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      const payload = {
        companyId: values.companyId,
        companyName: values.companyName,
        brandName: values.brandName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        gstNo: values.gstNo,
        panCard: values.panCard,
        address: values.address,
        city: values.city,
        state: values.state,
        country: values.country,
        currency: values.currency,
        companyType: values.companyType,
        parentCompanyId: user?.cid,
        isActive: values.isActive,
        password: values.password,
        roleName: "AGENT",
        password: "Test@123",
        planType: values.planType,
        userType: values.userType,
      };
      try {
        const isNew =
          payload.companyId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.REGISTERCOMPANY, payload);
        } else {
          await apiService.create(config.UPDATEB2BCOMPANY, payload);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = [
      "companyName",
      "brandName",
      "gstNo",
      "city",
      "state",
    ];

    let finalValue;
    if (name === "isActive") {
      finalValue = value === "true";
    } else if (fieldsToUppercase.includes(name)) {
      finalValue = value.toUpperCase();
    } else {
      finalValue = value;
    }

    // When country changes, update both country and currency
    if (name === "country") {
      const selectedCountry = countries.find(
        (country) => country.countryCode === value
      );
      setValues({
        ...values,
        country: value,
        currency: selectedCountry?.code || getUserDefaultCurrency(),
      });
    }
    // When currency is manually changed, update only currency
    else if (name === "currency") {
      setValues({
        ...values,
        currency: value,
      });
    } else {
      setValues({
        ...values,
        [name]: finalValue,
      });
    }
  };

  const resetForm = () => {
    setValues({
      companyId: "00000000-0000-0000-0000-000000000000",
      companyName: "",
      brandName: "",
      gstNo: "",
      email: "",
      phoneNumber: "",
      logoName: "",
      address: "",
      city: "",
      state: "",
      country: getUserDefaultCountry(),
      currency: getUserDefaultCurrency(),
      companyType: "AGENT",
      parentCompanyId: "00000000-0000-0000-0000-000000000000",
      isActive: true,
      planType: "CUSTOM",
      userType: "AGENT",
    });
    setAddShow(false);
    setAddCommissionShow(false);
    setShowPassword(false);
    setShowWallet(false);
    setBtnLoading(false);
    setNewPassword("");
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AgentTabs pageName="AGENT" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-8">
                      <div className="d-flex gap-2 align-items-center flex-wrap">
                        <div className="search-box flex-grow-1">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search by name or email..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>

                        <div className="flex-shrink-0">
                          <select
                            className="form-select form-select-sm"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ height: "38px", whiteSpace: "nowrap" }}
                          >
                            <option value="ALL">All Status</option>
                            <option value="ACTIVE">Active</option>
                            <option value="INACTIVE">Inactive</option>
                          </select>
                        </div>

                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={handleClearFilters}
                          style={{ height: "38px", whiteSpace: "nowrap" }}
                        >
                          <i className="ri-refresh-line align-bottom me-1"></i>
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className="col-sm-4 ms-auto">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Agent
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>S.NO</th>
                          <th>Agent Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Wallet</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {filteredLists.length > 0 ? (
                          filteredLists.map((v, index) => (
                            <tr key={v.companyId}>
                              <td>{index + 1}</td>
                              <td>{v.companyName}</td>
                              <td>{v.email}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.walletBalance} {v.currency}</td>
                              <td>
                                {v.isActive === true ? (
                                  <span className="badge bg-success">
                                    ACTIVE
                                  </span>
                                ) : (
                                  <span className="badge bg-danger">
                                    IN-ACTIVE
                                  </span>
                                )}
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.companyId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  {/* <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Commission"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleAddCommissionShow(v.companyId)
                                      }
                                    >
                                      <i className="ri-wallet-2-line align-bottom text-muted" />
                                    </Link>
                                  </li> */}
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Add TopUp"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleWalletShow(v.companyId)
                                      }
                                    >
                                      <i className="ri-wallet-2-line align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Change Password"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handlePasswordShow(v.companyId)
                                      }
                                    >
                                      <i className="ri-eye-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <div className="text-muted">
                                <i className="ri-user-shared-line display-4"></i>
                                <p className="mt-2">
                                  {searchTerm || statusFilter !== "ALL"
                                    ? "No agents found matching your criteria"
                                    : "No agents found"}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">
                          {filteredLists.length}
                        </span>{" "}
                        of <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header>
            <Modal.Title>
              {values.companyId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Company
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="Please Enter Company Name"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="brandName" className="form-label">
                    Brand Name
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.brandName}
                    name="brandName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("brandName")}
                    placeholder="Please Enter Brand Name"
                  />
                  {errors.brandName === false ? (
                    <div className="validationerror">
                      Please enter brand name{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("email")}
                    placeholder="Please enter email"
                  />
                  {errors.email === false ? (
                    <div className="validationerror">Please enter email </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="mobile" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    max={15}
                    value={values.phoneNumber}
                    name="phoneNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("phoneNumber")}
                    placeholder="Please enter phone"
                  />
                  {errors.phoneNumber === false ? (
                    <div className="validationerror">
                      Please enter phone number{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="gstNo" className="form-label">
                    GST Number
                  </label>
                  <input
                    type="text"
                    max={15}
                    value={values.gstNo}
                    name="gstNo"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("gstNo")}
                    placeholder="Please enter gst no"
                  />
                  {errors.gstNo === false ? (
                    <div className="validationerror">
                      Please enter gst number{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.city}
                    name="city"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("city")}
                    placeholder="City"
                  />
                  {errors.city === false ? (
                    <div className="validationerror">Please enter city </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.state}
                    name="state"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("state")}
                    placeholder="State"
                  />
                  {errors.state === false ? (
                    <div className="validationerror">Please enter state </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="country" className="form-label">
                    Country
                  </label>
                  <select
                    className="form-select"
                    value={values.country}
                    name="country"
                    onChange={handleInputChange}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option
                        key={country.countryCode}
                        value={country.countryCode}
                      >
                        {country.flag && (
                          <img
                            src={country.flag}
                            alt={country.country}
                            style={{
                              width: "20px",
                              height: "15px",
                              marginRight: "8px",
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                        {country.country} - {country.countryCode}
                        {country.countryCode === getUserDefaultCountry()}
                      </option>
                    ))}
                  </select>
                  {errors.country === false ? (
                    <div className="validationerror">
                      Please select country{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="currency" className="form-label">
                    Currency
                  </label>
                  <select
                    className="form-select"
                    value={values.currency}
                    name="currency"
                    onChange={handleInputChange}
                  >
                    <option value="">Select Currency</option>
                    {countries.map((country) => (
                      <option key={country.countryCode} value={country.code}>
                        {country.flag && (
                          <img
                            src={country.flag}
                            alt={country.country}
                            style={{
                              width: "20px",
                              height: "15px",
                              marginRight: "8px",
                              verticalAlign: "middle",
                            }}
                          />
                        )}
                        {country.country} - {country.code}
                        {country.currency && ` (${country.currency})`}
                        {country.code === getUserDefaultCurrency()}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="isActive" className="form-label">
                    STATUS
                  </label>
                  <select
                    name="isActive"
                    value={values.isActive}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("isActive")}
                  >
                    <option value={true}>ACTIVE</option>
                    <option value={false}>IN-ACTIVE</option>
                  </select>
                </div>
                <div className="col-lg-8 mb-3">
                  <label htmlFor="address" className="form-label">
                    Address
                  </label>
                  <input
                    type="text"
                    max={200}
                    value={values.address}
                    name="address"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("address")}
                    placeholder="Address"
                  />
                  {errors.address === false ? (
                    <div className="validationerror">Please enter address </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.companyId ===
                          "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          show={addCommissionShow}
          onHide={handleAddCommissionClose}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>COMMISSION DETAILS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-4 mb-3">
                  <label htmlFor="isActive" className="form-label">
                    Type
                  </label>
                  <select
                    name="isActive"
                    value={values.isActive}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("isActive")}
                  >
                    <option value="AMOUNT">AMOUNT</option>
                    <option value="PERCENTAGE">PERCENTAGE</option>
                  </select>
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Flight Domestic
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="5 OR 5000"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Flight International
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="5 OR 5000"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="isActive" className="form-label">
                    Type
                  </label>
                  <select
                    name="isActive"
                    value={values.isActive}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("isActive")}
                  >
                    <option value="AMOUNT">AMOUNT</option>
                    <option value="PERCENTAGE">PERCENTAGE</option>
                  </select>
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Hotel Domestic
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="5 OR 5000"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-4 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    Hotel International
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={values.companyName}
                    name="companyName"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="5 OR 5000"
                  />
                  {errors.companyName === false ? (
                    <div className="validationerror">Please enter name </div>
                  ) : (
                    ""
                  )}
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.companyId ===
                          "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          show={showPassword}
          onHide={handlePasswordClose}
          size="md"
        >
          <Modal.Header>
            <Modal.Title>Change Agent Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handlePasswordSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="companyName" className="form-label">
                    New Password
                  </label>
                  <input
                    type="password"
                    max={45}
                    value={newPassword}
                    name="newPassword"
                    onChange={(e) => setNewPassword(e.target.value)}
                    className={"form-control" + applyErrorClass("companyName")}
                    placeholder="Enter new password"
                  />
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">Change Password</button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          show={showWallet}
          onHide={handleWalletClose}
          size="md"
        >
          <Modal.Header>
            <Modal.Title>Add Topup</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleWalletSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-lg-12 mb-3">
                  <label htmlFor="walletAmount" className="form-label">
                    Enter Amount
                  </label>
                  <input
                    type="text"
                    max={45}
                    value={walletAmount}
                    name="walletAmount"
                    onChange={(e) => setWalletAmount(e.target.value)}
                    className={"form-control" + applyErrorClass("walletAmount")}
                    placeholder="Enter Topup Amount"
                  />
                </div>
                <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">Update Topup</button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <CompanyMenu
          show={showMenuModal}
          handleClose={handleCloseMenuModal}
          companyId={menuItem}
        ></CompanyMenu>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default Agent;
